import React from 'react'
import { useIntl } from 'react-intl'
import { CANCEL } from 'app/constants/button'
import { useGroupDialog } from '../contexts/GroupDialogContext'
import SubmitDialog from 'app/componentV4/Dialog/SubmitDialog'
import { DIALOG_KEYS } from '../constants'

const DeleteSubGroup = () => {
  const { formatMessage } = useIntl()
  const { dialogState, closeDialog } = useGroupDialog()
  const { open, action, isLoading } = dialogState[DIALOG_KEYS.SUB_GROUP_DELETE]

  const handleSubmit = () => {
    action?.onSubmit?.()
  }

  return (
    <SubmitDialog
      id="dialog-delete-subgroup"
      open={open}
      type={CANCEL}
      title={`${formatMessage({ id: 'groupsv4.subgroup.deleted.message' })}?`}
      description={formatMessage({
        id: 'groupsv4.delete.subgroup.description',
      })}
      isLoading={isLoading}
      submitText={formatMessage({
        id: 'action.delete',
      })}
      onSubmit={handleSubmit}
      closeText={formatMessage({
        id: 'text.close',
      })}
      onClose={() => closeDialog(DIALOG_KEYS.SUB_GROUP_DELETE)}
    />
  )
}

export default DeleteSubGroup
